import { defineMessages } from 'react-intl'

export default defineMessages({
  'seasonTitle': {
    id: 'seasonTitle',
    defaultMessage: 'Season',
  },
  'seasonMessage': {
    id: 'seasonMessage',
    defaultMessage: 'Loading Seasonal Data',
  },
  'recommendationTitle': {
    id: 'recommendationTitle',
    defaultMessage: 'Recommendations',
  },
  'recommendationMessage': {
    id: 'recommendationMessage',
    defaultMessage: 'Loading Entries',
  },
  'assetTitle': {
    id: 'assetTitle',
    defaultMessage: 'Assets',
  },
  'assetMessage': {
    id: 'assetMessage',
    defaultMessage: 'Loading Data',
  },
  'jobsTitle': {
    id: 'jobsTitle',
    defaultMessage: 'jobs',
  },
  'jobsMessage': {
    id: 'jobsMessage',
    defaultMessage: 'Loading Entries',
  },
  'usersTitle': {
    id: 'usersTitle',
    defaultMessage: 'Users',
  },
  'usersMessage': {
    id: 'usersMessage',
    defaultMessage: 'Loading Data',
  },
  'soilTitle': {
    id: 'soilTitle',
    defaultMessage: 'Soil',
  },
  'soilMessage': {
    id: 'soilMessage',
    defaultMessage: 'Loading Soil Information',
  },
  'clientTitle': {
    id: 'clientTitle',
    defaultMessage: 'Client',
  },
  'clientMessage': {
    id: 'clientMessage',
    defaultMessage: 'Loading Client Details',
  },
  'suppliesTitle': {
    id: 'suppliesTitle',
    defaultMessage: 'Supplies',
  },
  'suppliesMessage': {
    id: 'suppliesMessage',
    defaultMessage: 'Loading Data',
  },
  'environmentTitle': {
    id: 'environmentTitle',
    defaultMessage: 'Environment',
  },
  'environmentMessage': {
    id: 'environmentMessage',
    defaultMessage: 'Loading Changes',
  },
  'fertilizerTitle': {
    id: 'fertilizerTitle',
    defaultMessage: 'Fertilizers',
  },
  'fertilizerMessage': {
    id: 'fertilizerMessage',
    defaultMessage: 'Loading Products',
  },
  'mapTitle': {
    id: 'mapTitle',
    defaultMessage: 'Map',
  },
  'mapMessage': {
    id: 'mapMessage',
    defaultMessage: 'Loading Data',
  },
  'unknownTitle': {
    id: 'unknownTitle',
    defaultMessage: 'Request',
  },
  'unknownMessage': {
    id: 'unknownMessage',
    defaultMessage: 'Loading Data',
  },
})
